<script setup>
import { cdnImageUrl } from '@dpgradio/creative'
import AnimatedSkewedEllipsMask from '../kijk_live_qmusic_nl_default/shared/AnimatedSkewedEllipsMask.vue'
import { onMounted, watch } from 'vue'
import CharacterJumpFromTheRight from '../kijk_live_qmusic_nl_default/text_animations/CharacterJumpFromTheRight.vue'
const gsapTimeline = useGsapTimeline()

const { item } = defineProps({
  item: Object,
})

const data = ref({
  imageUrl: null,
  position: null,
})

const maskElement = ref(null)
const imageElement = ref(null)

const ellipsTimeline = ref(null)
const timelinePosition = ref(null)

const setData = (newItem) => {
  const currentImage = newItem.enrichment.track.artist.photo || newItem.enrichment.track.thumbnail
  const edition = newItem.enrichment.track.activeEditions?.[0]

  data.value.imageUrl = cdnImageUrl(currentImage)
  data.value.position = edition?.position ? `#${edition.position}` : null
}

setData(item)

const doAppear = () => {
  ellipsTimeline.value.reversed(false)
  timelinePosition.value?.reversed(false)

  gsapTimeline({ name: 'NowPlaying' })
    .add(ellipsTimeline)
    .from(imageElement.value, { scale: 1.2, duration: 2, ease: 'back.out(1.2)' }, '<')
    .to(maskElement.value, { scale: 1.06, duration: 6, ease: 'sine.inOut', repeat: -1, yoyo: true })
    .add(timelinePosition, '=-7.4')
}

const doDisappear = async () => {
  ellipsTimeline.value.reversed(true)
  timelinePosition.value?.reversed(true)

  await gsapTimeline({ name: 'NowPlaying - Disappear' }).add(timelinePosition).add(ellipsTimeline, 0.5)
}

onMounted(doAppear)

const { onDisappear } = useDisappearable()
onDisappear(async () => doDisappear())

watch(
  () => item,
  async (newItem) => {
    await doDisappear()

    setData(newItem)

    await doAppear()
  }
)
</script>

<template>
  <div class="size-full flex items-center justify-center">
    <AnimatedSkewedEllipsMask v-if="data.imageUrl" ref="maskElement" class="size-[86rem] mr-24" @timeline="ellipsTimeline = $event">
      <img ref="imageElement" :src="data.imageUrl" class="w-full h-full object-cover scale-105" />
    </AnimatedSkewedEllipsMask>
    <CharacterJumpFromTheRight
      v-if="data.position"
      :key="data.position"
      :text="data.position"
      class="text-white !absolute top-[200px] left-[1000px]"
      textSizeClass="text-[14em]"
      textOutlineSizeClass="text-[22.4em]"
      @timeline="timelinePosition = $event"
    />
  </div>
</template>
